<template>
    <div v-loading="fullscreenLoading" element-loading-background="rgba(255, 255, 255, 0.4)">
        <div style="overflow:hidden">
            <el-button style="float:right" type="primary" size="mini" @click="load">刷新</el-button>
            <el-button v-show="gridData.length" type="primary" size="mini" @click="newList">新订单（{{gridData.length}}）</el-button>
        </div>
        <div style="display:flex;justify-content: flex-start;">
            <div class="Thespli"><div class="specimen_a"></div>未使用</div>
            <div class="Thespli"><div class="specimen_b"></div>待确认</div>
            <div class="Thespli"><div class="specimen"></div>待支付</div>
        </div>
        <br>
        <el-row :gutter="10">
            <el-col :xs="12" :sm="12" :md="8" :lg="6" v-for="item in List" :key="item.orderId">
                <div class="grid-content"  @click="click_(item)" :class="{'bg-purple': item.tcInUse==1&&(item.orderStatus==1||item.orderStatus==0),'bg-class':item.tcInUse==1&&item.orderStatus==8,}"> 
                    <div class="title">{{item.tcNo}}号 <span style="float:right">{{item.tcName}}</span></div>
                    <div class="center">可供人数{{item.tcCapacity}}位</div>
                    <div class="li">
                        <div> 
                            <div>菜品数量 : {{item.goodsNum}}</div>
                        </div>
                        <div>
                            <div>订单金额 : {{(item.orderAmt/100).toFixed(2)}}</div>
                        </div>
                        <div>
                            <div>就餐时间 : {{item.tcUseTs}}</div>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-dialog title="桌位订单" :visible.sync="dialogTableVisible" width="840px">
            <dialog-details :togg="newTogg" :data="data" :load="load" @load="load" :newList="newList" @close="dialogTableVisible=false"  v-if="dialogTableVisible"></dialog-details>
        </el-dialog>
        <el-dialog title="订单详情" :visible.sync="dialogTableVisible_" width='500px'>
            <el-form :inline="true" size="mini" :model="showform" class="demo-form-inline">
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="桌位编号:" prop="name">
                            {{showform.tcNo}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="16">
                        <el-form-item label="订单编号:" prop="name">
                            {{showform.id}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row> 
                    <el-col :span="8">
                        <el-form-item label="订单状态:" prop="name">
                            {{option[showform.status]}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="16">
                        <el-form-item label="订单时间:" prop="name">
                            {{showform.rowCrtTs | formatDate("yyyy-MM-dd hh:mm:ss")}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="16">
                        <el-form-item label="交易流水号:" prop="name">
                            {{showform.tradeNo}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="订单金额:" prop="name">
                            {{(showform.orderAmt/100).toFixed(2)}}元
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="12">
                        <el-form-item label="订单类型：" prop="name">
                            新订单
                        </el-form-item>
                    </el-col> -->
                </el-row>
            </el-form>
            <el-table header-cell-class-name="cen" cell-class-name="cen" :data="showform.goodsList">
                <el-table-column label="序号" type="index" width="55px"></el-table-column>
                <el-table-column property="gdName" label="菜品名称"></el-table-column>
                <el-table-column property="gdNum" label="数量"></el-table-column>
                <el-table-column property="gdAmt" label="金额">
                    <template slot-scope="scope">
                        {{(scope.row.gdAmt/100).toFixed(2)}}元
                    </template>
                </el-table-column>
            </el-table>
            <div style="text-align:center;margin:10px 0;">
                <el-button :loading="TT" size="mini" type="primary" @click="donwOrder(showform.id)">确认下单</el-button>
                 <el-button :loading="TT" size="mini" type="primary" @click="closefirm(showform.id)">取消下单</el-button>
            </div>
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-col :span="5">订单备注:</el-col>
                    <el-col :span="19" v-html="showform.memo"></el-col>
                </el-col>
            </el-row>
        </el-dialog>
        <el-dialog title="最新订单" :visible.sync="dialogVisible" width="850px">
            <el-table :data="gridData" size="mini" @row-click='clickCallback'>
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column property="tcNo" label="桌号"></el-table-column>
                <el-table-column property="id" label="订单编号" width="180"></el-table-column>
                <el-table-column property="rowCrtTs" label="时间">
                    <template slot-scope="scope">
                        {{scope.row.rowCrtTs|formatDate('yyyy-MM-dd hh:mm:ss')}}
                    </template>
                </el-table-column>
                <el-table-column property="gdNum" label="总数量"></el-table-column>
                <el-table-column label="总金额">
                    <template slot-scope="scope">
                        {{(scope.row.orderAmt/100).toFixed(2)}}
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import Eve from "../../../components/common/emit.js";
import dialogDetails from "./dialogDetails";
import { mapMutations } from "vuex";
export default {
  components: { dialogDetails },
  methods: {
    ...mapMutations([
      "deleOrderData" // 将 `this.addOrderData(amount)` 映射为 `this.$store.commit('addOrderData', amount)`
    ]),
    donwOrder(id) {
      this.TT = true;
      this.$http.post(`/w/businessStatus/confirmOrder?orderId=${id}`).then(
        data => {
          this.$message({
            type: "success",
            message: "确认下单成功"
          });
          this.load();
          this.dialogVisible = false;
          this.dialogTableVisible_ = false;
          this.deleOrderData(id);
          this.TT = false;
        },
        err => {
          this.TT = false;
        }
      );
    },
    closefirm(id) {
      this.TT = true;
      this.$http.post(`/w/businessStatus/cancelOrder?orderId=${id}`).then(
        data => {
          this.$message({
            type: "success",
            message: "取消订单成功"
          });
          this.load();
          this.dialogVisible = false;
          this.dialogTableVisible_ = false;
          this.deleOrderData(id);
          this.TT = false;
        },
        err => {
          this.TT = false;
        }
      );
    },
    click_(obj) {
      if (obj.tcInUse != 0) {
        this.$http
          .post(`/w/businessStatus/detail?orderId=${obj.orderId}`)
          .then(data => {
            this.data = data.data;
            this.dialogTableVisible = true;
          });
      } else {
        this.$message.error("桌位暂时未使用!");
      }
    },
    click(obj) {
      this.dialogTableVisible_ = true;
      this.$http.post(`/w/order/detail/single/${obj.id}`).then(data => {
        this.showform = data.data;
        !this.showform.goodsList && (this.showform.goodsList = []);
      });
    },
    List_() {
      return this.$http.post(`/w/businessStatus/confirmList`).then(d => {
        this.gridData = d.data;
        return d.data;
      });
    },
    newList() {
      this.List_().then(obj => {       
        if(obj.length!=0){
          this.dialogVisible = true;
          this.$http
          .post(`/w/businessStatus/toConfirm?orderIdsStr=${obj.join(",")}`)
          .then(d => {
            this.gridData = d.data;
          });
        }else{
          this.$message('暂时没有新订单！');
        }       
      });
    },
    clickCallback(row, event, column) {
      this.click(row);
    },
    load() {
      this.fullscreenLoading = true;
      this.$http.post("/w/businessStatus/s?page=0&size=100",{}).then(
        data => {
          this.List = data.data;
          this.fullscreenLoading = false;
        },
        err => {
          this.fullscreenLoading = false;
        }
      );
    }
  },
  data() {
    return {
      TT: false,
      payTypeArr: {
        0: "微信",
        1: "支付宝",
        2: "现金"
      },
      option: {
        0: "待支付",
        1: "待支付",
        2: "支付成功",
        3: "支付失败",
        4: "已取消",
        8: "待确认"
      },
      dialogTableVisible_: false,
      showform: {},
      newTogg: "",
      fullscreenLoading: false,
      orderIdList: this.$store.state.orderList.list,
      data: {},
      dialogVisible: false,
      gridData: [],
      id: "",
      dialogTableVisible: false,
      List: []
    };
  },
  created() {
    Eve.$on("businessStatusList", () => {
      this.load();
      this.List_();
    });
    this.load();
    this.List_();
  }
};
</script>

<style scoped>
.Thespli {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  margin-right: 20px;
}
.specimen,
.specimen_a,
.specimen_b {
  width: 60px;
  height: 18px;
  background: #ff5d5d;
  margin-right: 10px;
}
.specimen_a {
  background: #eceff1;
}
.specimen_b {
  background: orange;
}
.el-col {
  border-radius: 4px;
}

.title {
  font-size: 16px;
  width: 90%;
  margin: 0 auto;
}
.center {
  text-align: center;
  margin-top: 10px;
}
.grid-content {
  cursor: pointer;
  color: #000;
  border-radius: 4px;
  min-height: 100px;
  margin-bottom: 10px;
  padding: 10px 0;
  font-size: 14px;
  background: #f9fafb;
  box-shadow: inset 0 0 35px 5px rgba(197, 197, 197, 0.25),
    inset 0 2px 1px 1px rgba(236, 236, 236, 0.9),
    inset 0 -2px 1px 0 rgb(210, 206, 206);
}
.bg-purple {
  cursor: pointer;
  color: #fff !important;
  background: #ff5d5d;
  box-shadow: inset 0 0 35px 5px rgba(255, 69, 69, 0.25),
    inset 0 2px 1px 1px rgba(224, 112, 112, 0.9),
    inset 0 -2px 1px 0 rgb(193, 80, 80);
}
.bg-class {
  color: #fff !important;
  background: orange !important;
  box-shadow: inset 0 0 35px 5px #f1aa28,
    inset 0 2px 1px 1px rgba(236, 236, 236, 0.9),
    inset 0 -2px 1px 0 rgb(210, 206, 206);
}
.li {
  width: 90%;
  margin: 10px auto;
}
.li > div {
  display: flex;
}
.el-button + .el-button {
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/view/page/operatingState/operatingState.vue